import { getConfig } from '@acast-tech/product-suite-app-shell';
import config from './config';

const appConfig = getConfig(config.env !== 'prod' ? 'development' : 'production');
appConfig.openUrl = config.baseUrl;

export { appConfig };
